import {
  IAppointment,
  IOrganisation,
  IPatient,
  IPractice,
  IStaffer,
  ITreatmentCategory,
  ITreatmentPlanPairFromTemplate,
  ITreatmentPlanWithBookableStep,
  ITreatmentTemplateWithStep,
} from '@principle-theorem/principle-core/interfaces';
import { Appointment } from '../../appointment/appointment';
import { IAppointmentDetails } from '../../appointment-store/appointment-details';
import { INamedDocument, WithRef } from '@principle-theorem/shared';
import { FeeSchedule } from '../fees/fee-schedule/fee-schedule';
import { AppointmentTreatmentPlanAssociator } from '../../appointment-store/appointment-treatment-plan-associator';
import { first } from 'lodash';
import { isDefaultOption } from '../../appointment-store/default-option';

export async function getPlanWithBookableStep(
  appointment: IAppointment
): Promise<ITreatmentPlanWithBookableStep> {
  const plan = await Appointment.treatmentPlan(appointment);
  const step = await Appointment.treatmentStep(appointment);
  return {
    plan,
    step,
  };
}

export async function convertTemplateToPlanPair(
  template: ITreatmentTemplateWithStep,
  details: IAppointmentDetails,
  patient: WithRef<IPatient> | undefined,
  organisation: WithRef<IOrganisation>,
  treatmentCategories: WithRef<ITreatmentCategory>[],
  practice?: WithRef<IPractice>
): Promise<ITreatmentPlanPairFromTemplate> {
  const feeSchedule = await FeeSchedule.getPreferredOrDefault(
    organisation,
    practice?.settings.defaultFeeSchedule,
    patient?.preferredFeeSchedule?.ref
  );

  const practitioner = getPractitionerFromDetailsOrTemplate(details, template);

  const { plan, steps } =
    await AppointmentTreatmentPlanAssociator.getTreatmentPlanStepsPair(
      template,
      feeSchedule,
      treatmentCategories,
      practitioner
    );

  // TODO: CU-2tyu87g Allow treatment tempaltes with multiple steps to be
  // added when booking an appointment.
  return { plan, step: first(steps) } as ITreatmentPlanPairFromTemplate;
}

function getPractitionerFromDetailsOrTemplate(
  details: IAppointmentDetails,
  template: ITreatmentTemplateWithStep
): INamedDocument<IStaffer> | undefined {
  const fromDetails = isDefaultOption(details.practitioner)
    ? undefined
    : details.practitioner;

  return fromDetails ?? template.plan.practitioner;
}
